import React from 'react';
import { Box, Container, Grid, Typography, TextField, Button, Card, useTheme } from '@mui/material';
import { LocationOn, Phone, Email } from '@mui/icons-material';
import Navbar from './layout/Navbar';
import Footer from './layout/Footer';

const ContactPage = () => {
  const theme = useTheme();

  return (
    <>
    <Navbar/>
    <Box sx={{ backgroundColor: theme.palette.background.default }}>
      {/* Contact Section */}
      <Container maxWidth="lg" sx={{ py: 8 }}>
        <Typography variant="h3" component="h1" gutterBottom sx={{ 
          color: '#1E7CB7',
          fontWeight: 600,
          mb: 6,
          textAlign: 'center'
        }}>
          Get in Touch
        </Typography>

        <Grid container spacing={6}>
          {/* Contact Form */}
          <Grid item xs={12} md={6}>
            <Card sx={{ 
              p: 4,
              borderRadius: 4,
              boxShadow: '0 8px 32px rgba(0, 0, 0, 0.05)'
            }}>
              <Typography variant="h5" gutterBottom sx={{ 
                color: '#1E7CB7',
                fontWeight: 600,
                mb: 3
              }}>
                Send us a Message
              </Typography>
              
              <form>
                <Grid container spacing={3}>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Your Name"
                      variant="outlined"
                      required
                      sx={{
                        '& .MuiOutlinedInput-root': {
                          borderRadius: 2,
                        }
                      }}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Email Address"
                      type="email"
                      variant="outlined"
                      required
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Message"
                      multiline
                      rows={4}
                      variant="outlined"
                      required
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Button
                      fullWidth
                      variant="contained"
                      size="large"
                      sx={{
                        backgroundColor: '#2FA8EF',
                        '&:hover': { backgroundColor: '#1E7CB7' },
                        borderRadius: 2,
                        py: 1.5,
                        textTransform: 'none',
                        fontSize: '1rem'
                      }}
                    >
                      Send Message
                    </Button>
                  </Grid>
                </Grid>
              </form>
            </Card>
          </Grid>

          {/* Contact Info */}
          <Grid item xs={12} md={6}>
            <Card sx={{ 
              p: 4,
              backgroundColor: '#1E7CB7',
              color: 'white',
              borderRadius: 4,
              height: '100%'
            }}>
              <Typography variant="h5" gutterBottom sx={{ 
                fontWeight: 600,
                mb: 4
              }}>
                Our Corporate Office
              </Typography>

              <Box sx={{ mb: 4 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                  <LocationOn sx={{ mr: 2, color: '#2FA8EF' }} />
                  <Typography>
                    Bluebird Complex, Tripureswore<br />
                    Kathmandu Metropolitan City,<br />
                    Ward no. 11, Nepal
                  </Typography>
                </Box>

                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                  <Phone sx={{ mr: 2, color: '#2FA8EF' }} />
                  <Typography>+977 1-5918717</Typography>
                </Box>

                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <Email sx={{ mr: 2, color: '#2FA8EF' }} />
                  <Typography>nepalmagnessa@gmail.com</Typography>
                </Box>
              </Box>

              {/* Map */}
              <Box sx={{ 
                borderRadius: 3,
                overflow: 'hidden',
                height: 300,
                border: '2px solid #2FA8EF'
              }}>
                <iframe
                  title="Office Location"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3533.3948335718546!2d85.30738731506119!3d27.67424738280435!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39eb19df007a9d3b%3A0x3e8a9c7e2e7e0b5a!2sTripureshwor%2C%20Kathmandu%2044600!5e0!3m2!1sen!2snp!4v162987654321!5m2!1sen!2snp"
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  loading="lazy"
                />
              </Box>
            </Card>
          </Grid>
        </Grid>

        <Typography variant="body2" sx={{ 
          textAlign: 'center',
          mt: 6,
          color: '#555'
        }}>
          We typically respond within 24-48 hours. For urgent inquiries, please call us directly.
        </Typography>
      </Container>
    </Box>
    <Footer/>
    </>
  );
};

export default ContactPage;